import { findingViewType_Parent } from './types.js';
export const cleanFindingView = Object.freeze({
    label: 'New Finding View',
    type: findingViewType_Parent,
    childrenIds: [],
    __findingViewIds: [],
    __contextRuleIds: [],
    __variableIds: [],
});
//# sourceMappingURL=consts.js.map